module.exports = __webpack_public_path__ + "static/img/IMG_20160611_143629.4d359daf.jpg";